<template>
  <div class="siderbar-warpper">
    <el-menu :router="true" :default-active="`${sysPath}/` + `${URL}/` + activeIndex" class="el-menu-demo" mode="vertical">
      <siderbar-item v-for="router in routes" :key="router.path" :item="router" :base-path="router.path"></siderbar-item>
    </el-menu>
  </div>
</template>

<script>
import siderbarItem from "./siderbarItem.vue";
export default {
  name: "SiderBar",
  data() {
    return {};
  },
  methods: {},
  computed: {
    routes() {
      // 从原始路由配置中取数据（与 NavBar 同一数据源）
      const sysRoute = this.$router.options.routes.find((e) => e.name === "sys");
      if (!sysRoute) return [];
      // 当前一级菜单（如 warningrelease）
      const section = this.$route.path.split("/")[2];
      const current = sysRoute.children.find((e) => e.path === section);
      return current ? current.children || [] : [];
    },
    sysPath() {
      const sysRoute = this.$router.options.routes.find((e) => e.name === "sys");
      return sysRoute ? sysRoute.path : "/sys";
    },
    activeIndex() {
      return this.$route.path.split("/")[3];
    },
    URL() {
      return this.$route.path.split("/")[2];
    },
  },
  components: {
    siderbarItem,
  },
};
</script>
<style lang="scss" scoped>
.siderbar-warpper {
  width: 100%;
  height: 100%;

  .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
  .el-menu--horizontal > .el-menu-item.is-active {
    background-color: #2851cd;
    color: orange;
  }

  .el-menu-item:not(.is-disabled):hover {
    background-color: #4b74ef;
  }

  .el-menu > .el-menu-item.is-active {
    background-color: #4b74ef;
    color: black;
  }
}
</style>
